import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.typing');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-typing',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.typing/view.scss */
:host {
  display: block;
}

.typing-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.typing-text-container {
  position: relative;
  line-height: 1;
  text-align: center;
  display: inline-block;
}
.typing-text-container .text {
  display: inline;
}
.typing-text-container .text-cursor {
  position: absolute;
  height: 100%;
  top: 0;
  right: -6px;
  background-color: transparent;
  border-left: 2px solid currentColor;
  animation: blink 0.8s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .text-cursor {
    animation: none;
    opacity: 1;
  }
}`],
})
export class ComponentTypingComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() text: any;
    @Input() style: any = {};
    @Input() cursorStyle: any = {};
    @Input() timelaps: number = 100;

    public _text: any = [];
    public current = { i: 0, j: 0 };

    public async ngOnInit() {
        await this.service.init();
        this._text = this.text.split("\n");
        for (let i = 0; i < this._text.length; i++)
            this._text[i] = this._text[i].split("");

        await this.service.render(this.timelaps);

        for (let i = 0; i < this._text.length; i++) {
            if (!this._text[i]) continue;
            this.current.i = i;
            for (let j = 0; j < this._text[i].length; j++) {
                this.current.j = j + 1;
                await this.service.render(this.timelaps);
            }
            await this.service.render(this.timelaps);
        }
    }

    public check(i: number, j: number) {
        if (i < this.current.i) return true;
        if (i == this.current.i && j < this.current.j) return true;
        return false;
    }
}

export default ComponentTypingComponent;